import { useEffect, useRef } from "react";
import { GeocoderAutocomplete } from "@geoapify/geocoder-autocomplete";
// import "@geoapify/geocoder-autocomplete/styles/minimal.css";

const LocationAutocomplete = ({
  value,
  onChange,
  isEditable,
  className,
  style,
}) => {
  const autocompleteRef = useRef(null);
  const autocompleteInstance = useRef(null);
  const selectListenerRef = useRef(null);

  useEffect(() => {
    if (!isEditable || !autocompleteRef.current) return;

    // Clean up previous instance by removing the container's children
    if (autocompleteRef.current) {
      while (autocompleteRef.current.firstChild) {
        autocompleteRef.current.removeChild(autocompleteRef.current.firstChild);
      }
    }

    // Create new instance
    autocompleteInstance.current = new GeocoderAutocomplete(
      autocompleteRef.current,
      "5f50c37a5b604cdfb7a4beb4d4376918", // Replace with your Geoapify API key
      {
        placeholder: "Unesite lokaciju",
        lang: "hr",
        debounceDelay: 100,
        allowNonVerifiedHouseNumber: true,
        filterByCountryCode: ["hr"],
        skipIcons: true,
        fontSize: 8,
        // filter: { type: "city,street,house" },
        bias: { countryCode: "hr" },
        // type: "postcode",
      },
    );

    // Set up event listener
    selectListenerRef.current = (location) => {
      if (location) {
        const formattedAddress = location.properties.formatted;
        onChange(formattedAddress, {
          lat: location.properties.lat,
          lng: location.properties.lon,
        });
      }
    };

    autocompleteInstance.current.on("select", selectListenerRef.current);

    // Set initial value if available
    if (value && autocompleteInstance.current) {
      autocompleteInstance.current.setValue(value);
    }

    // Cleanup function
    return () => {
      if (autocompleteInstance.current && selectListenerRef.current) {
        // Remove event listener if possible
        autocompleteInstance.current.off?.("select", selectListenerRef.current);
      }

      // Clean up by removing DOM elements
      if (autocompleteRef.current) {
        while (autocompleteRef.current.firstChild) {
          autocompleteRef.current.removeChild(
            autocompleteRef.current.firstChild,
          );
        }
      }

      autocompleteInstance.current = null;
    };
  }, [isEditable, onChange]);

  if (!isEditable) {
    return (
      <span className={className} style={style}>
        {value}
      </span>
    );
  }

  return (
    <div className="location-autocomplete-container">
      <div
        ref={autocompleteRef}
        // className={className}
        // style={{
        //   ...style,
        //   fontFamily: font ? `var(--font-${font})` : undefined,
        //   fontSize: fontSize ? `${fontSize}px` : undefined,
        // }}
      ></div>
    </div>
  );
};

export default LocationAutocomplete;
